"use client";

import { AppConfig } from "~/utils/AppConfig";
import { GoogleTagManager } from "@next/third-parties/google";

const GtmScript = () => {
    if (!AppConfig.isProduction) {
        return null;
    }

    return <GoogleTagManager gtmId="GTM-PRB3LC9N" />;};

export default GtmScript;